module.exports = __webpack_public_path__ + "img/horizontal_7_6_6000.76ca9073.png";